// eslint-disable-next-line import/prefer-default-export
export function mapSimpleGetters(array) {
  const out = {};

  array.forEach((key) => {
    out[key] = state => state[key];
  });

  return out;
}
